import { ModelFactory } from "@shared/factories/model.factory";
import {CompanyStakeholderType} from "@generated/graphql";
import {CompanyStakeholder} from "@modules/company/models/company-stakeholder.model";
import {companyShareholderFactory} from "@modules/company/factories/company-shareholder.factory";
import {
  companyIndirectShareholderFactory
} from "@modules/company/factories/company-indirect-shareholder.factory";
import {companyDirectorFactory} from "@modules/company/factories/company-director.factory";

export class CompanyStakeholderFactory extends ModelFactory<CompanyStakeholderType, CompanyStakeholder> {
  create (state: CompanyStakeholderType): CompanyStakeholder {
    if (state.__typename === 'CompanyDirectorType') {
      return companyDirectorFactory.tryCreating(state)
    }

    if (state.__typename === 'CompanyIndirectShareholderType') {
      return companyIndirectShareholderFactory.tryCreating(state)
    }

    return companyShareholderFactory.tryCreating(state)
  }

  fake (): CompanyStakeholder {
    throw new Error('This method is not implemented')
  }
}

export const companyStakeholderFactory = new CompanyStakeholderFactory()
